export interface IRegionItcPricing {
  fairMarketValue: number;
  minDevFee: number;
}

export class RegionItcPricing implements IRegionItcPricing {
  public fairMarketValue: number;
  public minDevFee: number;
}
